import * as ApiWithToken from "../callApiWithToken";

const apiUrl = process.env.REACT_APP_GENERAL_API;

const supportService = {
  getSupportList: async function (languageId: number, languageCode: string) {
    return ApiWithToken.getApiWithLanguage(
      `${apiUrl}Users/supportQuestions?languageID=${languageId}`,
      languageCode
    );
  },
  getSupportOptions: async function (languageId: number, languageCode: string) {
    return ApiWithToken.getApiWithLanguage(
      `${apiUrl}Users/getSupportOptions?languageID=${languageId}`,
      languageCode
    );
  },
  sendSupport: async function (payload: {
    shortDescription: string;
    description: string;
    userName: string;
  }) {
    return ApiWithToken.postApi(`${apiUrl}Users/sendSupport`, payload);
  },
};

export default supportService;
